import { mapGetters, mapActions } from 'vuex'

import MainButton from '@/components/MainButton/index'
import PublicPageWrapper from '@/components/PublicPageWrapper/index'
import Logo from '@/assets/the-long-ball-logo.svg'

export default {
  name: 'Login',
  components: {
    MainButton,
    PublicPageWrapper
  },
  data: () => ({
    loginForm: false,
    username: '',
    password: '',
    loginLoader: false,
    isFirstTimeUser: false,
    loginResponseDialog: false,
    Logo
  }),
  computed: {
    ...mapGetters('auth', {
      LOGIN_RESPONSE: 'LOGIN_RESPONSE',
      isAdmin: 'IS_ADMIN'
    })
  },
  methods: {
    ...mapActions('auth', {
      loginUser: 'LOGIN_USER'
    }),
    login() {
      this.loginLoader = true

      const payload = {
        usernameOrEmail: this.username,
        password: this.password
      }

      this.loginUser(payload)
    },
    dialogResponse() {
      this.loginResponseDialog = false
    },
    handleLoginRoute(isAdmin) {
      return isAdmin
        ? '/admin/settings'
        : !this.isFirstTimeUser
        ? '/app/dashboard'
        : '/app/engagement-rules'
    }
  },
  watch: {
    LOGIN_RESPONSE(data) {
      this.loginLoader = false

      if (data.success) {
        const { isFirstTimeUser } = data.data
        this.isFirstTimeUser = isFirstTimeUser
        this.username = ''
        this.password = ''
        this.$router.push({ path: this.handleLoginRoute(this.isAdmin) })
      } else {
        this.loginResponseDialog = true
      }
    }
  }
}
